















  import Chess from 'chess.js'
  import { PGN } from '../types'

  const placeholderText = `Enter or paste a PGN here to import your game

1. e4 e5 2. ...`

  const formatPgn = (pgn: string): PGN => {
    return pgn.trim().replace("0-0-0", "O-O-O").replace("0-0", "O-O").
      replace("‒", "-").
      replace("–", "-").
      replace("½-½", "1/2-1/2").
      replace("0.5-0.5", "1/2-1/2")
  }

  export default {
    data() {
      return {
        showError: false,
        showPgnInputButton: false,
        pgnIsValid: false,
        placeholderText,
      }
    },

    created() {
      this.cjs = new Chess
    },

    methods: {
      pgnInput() {
        return formatPgn(this.$refs.pgnInput.value)
      },
      validatePgn() {
        this.showError = false
        if (this.cjs.load_pgn(this.pgnInput())) {
          this.showPgnInputButton = true
          this.pgnIsValid = true
        } else {
          this.pgnIsValid = false
        }
      },

      loadPgn() {
        if (this.pgnIsValid) {
          this.$store.dispatch(`loadPgn`, this.pgnInput())
        } else {
          this.showError = true
        }
      }
    }
  }



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/pgn_importer.vue